import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { FranchiseAppGlobal } from "src/app/franchise-app-global";
import { AppConfigService } from "src/app/shared/providers/config.service";
import {
  FranchisesList,
  Franchises,
  FranchisesSearchModel,
} from "../models/franchise-admin-list";
import { FranchiseDetail } from "../models/franchise-detail";
import { FileDto } from "src/app/shared/models/models";
import { saveAs } from "file-saver";
@Injectable({
  providedIn: "root",
})
export class FranchisesAdminService {
  private env;
  constructor(private http: HttpClient, private config: AppConfigService) {
    this.env = config.getConfig();
  }

  franchises: FranchisesList[] = [];

  getAllAdminFranchises(
    searchModel: FranchisesSearchModel
  ): Observable<Franchises> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getFranchisesAdmin;
    return this.http.post<Franchises>(url, searchModel);
  }

  getFranchiseById(id: number): Observable<FranchiseDetail> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getFranchiseDetails + id;
    return this.http.get<FranchiseDetail>(url);
  }

  exportAllAdminFranchisesAsExcel(
    searchModel: FranchisesSearchModel
  ): Observable<FileDto> {
    let url =
      this.env.baseUrl + FranchiseAppGlobal.exportFranchisesAdminAsExcel;
    return this.http.post<FileDto>(url, searchModel);
  }
  exportAllAdminFranchisesAsPdf(
    searchModel: FranchisesSearchModel
  ): Observable<FileDto> {
    let url = this.env.baseUrl + FranchiseAppGlobal.exportFranchisesAdminAsPdf;
    return this.http.post<FileDto>(url, searchModel);
  }
  PrintFranchiseCertificate(franchiseNo: string) {
    let params: HttpParams = new HttpParams().set("franchiseNo", franchiseNo);
    let url =
      this.env.baseUrl +
      FranchiseAppGlobal.getFranchiseAdminCertificate +
      "?franchiseNo=" +
      franchiseNo;

    // console.log(url);
    this.http.get(url, { responseType: "blob" }).subscribe(
      (blob) => {
        saveAs(
          blob,
          "FranchiseCertificate.pdf" /*, { type: 'text/plain;charset=windows-1252' }*/
        );
      },
      (error) => { }
    );
  }
  getReasonsSelectByTypeId(id: number): Observable<any> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getReasonSelect + id;
    return this.http.get<any>(url);
  }
  getNextObjectid(): Observable<number> {
    let url = this.env.baseUrl + FranchiseAppGlobal.getNextObjectId;
    return this.http.get<number>(url);
  }
  addSuspededFranchiseSuspension(form: any): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.addSuspendedFranchiseSuspension;
    return this.http.post<void>(url, form);
  }
  addViolatedFranchiseSuspension(form: any): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.addViolatedFranchiseSuspension;
    return this.http.post<void>(url, form);
  }
  cancelFranchiseByAdmin(form: any): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.cancelFranchiseByAdmin;
    return this.http.post<void>(url, form);
  }
  removeViolatedFranchise(form: any): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.removeVoilatedFranchise;
    return this.http.post<void>(url, form);
  }
  removeSuspensionFranchise(form: any): Observable<void> {
    let url = this.env.baseUrl + FranchiseAppGlobal.removeSuspensionFranchise;
    return this.http.post<void>(url, form);
  }
}
